<template>
    <div class="content container">

        <hr>

        <h2 class="text-center">
            Anmeldung und Therapieumfang
        </h2>

        <hr>

        <div class="row">
            <div class="col-lg-6">
                <h4 class="text-center">Gesetzlich versicherte Patienten</h4>
                <ul>
                    <li>
                        Telefonische Vereinbarung eines Termins in der allgemeinen psychotherapeutischen Sprechstunde
                        zur Abklärung Ihres Anliegens und zur Klärung der Frage, ob eine behandlungsbedürftige
                        Symptomatik vorliegt.
                    </li>
                    <li>
                        In den anschließenden probatorischen Sitzungen werden wir herausfinden, ob wir gut miteinander
                        arbeiten können. Zudem geht es um eine ausführliche Diagnostik und die Erhebung ihrer Lebens-
                        bzw. Krankengeschichte.
                    </li>
                    <li>
                        Nach der Probatorik bewilligt die Krankenkasse antragsfrei bis zu 24 Stunden Kurzzeittherapie.
                        Je nach Dauer und Schwere der Symptomatik kann auch ein Antrag auf eine Langzeittherapie bei
                        Ihrer Krankenkasse gestellt werden. Diese umfasst dann 60 - 80 Therapiestunden. Ferner gibt es
                        die Möglichkeit in dringenden Fällen 12 Stunden Akuttherapie durchzuführen.
                    </li>
                    <li>
                        Nach Abschluss der Therapie können bis zu drei Termine im Quartal wahrgenommen werden, welche
                        zur Nachsorge und Stabilisierung der Therapieerfolge dienen.
                    </li>

                </ul>
            </div>
            <div class="col-lg-6">
                <h4 class="text-center">Privat versicherte Patienten</h4>
                Informieren Sie sich bitte vorab bei Ihrer Krankenkasse in welchem Rahmen und unter welchen Bedingungen
                die Kosten für eine Psychotherapie übernommen werden. Häufig orientieren diese sich jedoch an dem
                Vorgehen der gesetzlichen Krankenkassen.
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ContentApplication',
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {

    }
</style>
